import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";
import { initialDataWithPagination } from "services/api/consts";
import { FLEET_VEHICLE_CONTRACT_RENT_SEARCH_COLUMNS } from "./consts";
import { VehicleContractRentSearchResultsProps } from "./types";
import { useTranslate } from "helpers";

const VehicleContractRentSearchResults: React.FC<VehicleContractRentSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onContactClick,
    onDeleteClick,
  } = props;

  const { t } = useTranslate();

  const handleContactClick = (event: React.MouseEvent<HTMLDivElement>, id: string) => {
    if (onContactClick) onContactClick(event, id);
  };

  return (
    <>
      <TableSearch
        columns={FLEET_VEHICLE_CONTRACT_RENT_SEARCH_COLUMNS(t, handleContactClick, onDeleteClick)}
        data={searchResults.data}
        selectedRows={selectedRows}
        pagination={
          searchResults.pagination || initialDataWithPagination.pagination
        }
        selectableRows={false}
        disablePagination={true}
        onPaginationChange={onPaginationChange}
        onSelectedChange={onSelectedChange}
        isLoading={isLoading}
        onRowClick={onRowClick}
      />
    </>
  );
};

export default memo(VehicleContractRentSearchResults);
